import { jsx as _jsx } from "react/jsx-runtime";
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useRef, useState } from "react";
import { zIndexLayers } from "../../common/zIndexLayers";
import { getTooltipOffset, NewTooltip } from "../tooltip/NewTooltip";
import { NewButton } from "./NewButton";
const hideTimeout = 1500;
export const CopyButton = ({ beforeCopyContent, afterCopyContent, copyContent, tooltipOptions, action, ...buttonProps }) => {
    const tippyInstance = useRef(null);
    const [copied, setCopied] = useState(null);
    const clear = useCallback(() => {
        copied && clearTimeout(copied);
    }, [copied]);
    const handleCopy = useCallback((text) => {
        navigator?.clipboard?.writeText(text)?.then(() => {
            clear();
            if (!tippyInstance.current?.state.isVisible) {
                tippyInstance.current?.show();
            }
            setCopied(setTimeout(() => {
                tippyInstance.current?.hide();
                clear();
            }, hideTimeout));
        });
    }, [clear]);
    const handleHover = useCallback(() => {
        tippyInstance.current?.show();
    }, []);
    const handleHide = useCallback(() => {
        tippyInstance.current?.hide();
        copied && clearTimeout(copied);
    }, [copied]);
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        action?.();
        handleCopy(copyContent || "");
    }, [action, copyContent, handleCopy]);
    return (_jsx(NewTooltip, { immediatelyMount: true, hideOnClick: false, trigger: "manual", disabled: !beforeCopyContent && !afterCopyContent, delay: [0, 0], content: copied ? afterCopyContent : beforeCopyContent, hideArrow: !!copied, placement: "bottom", offset: copied ? getTooltipOffset(4, 0) : getTooltipOffset(4), appendTo: document.body, onCreate: (instance) => {
            tippyInstance.current = instance;
        }, onHidden: () => {
            setCopied(null);
        }, popperOptions: { strategy: "fixed" }, zIndex: zIndexLayers.tooltip, ...tooltipOptions, children: _jsx(NewButton, { type: "button", buttonType: "icon", icon: _jsx(FontAwesomeIcon, { icon: faCopy }), ...buttonProps, onMouseEnter: handleHover, onMouseLeave: handleHide, onClick: handleClick }) }));
};
